// App.tsx · v12.10.30 (#1155 #1156 #1157 BrowserPhoneHost around the signed-in app - the browser phone, the transfer overlay; #2259 Help & Support; #2255 practice offline) · 2026-11-03 · VoiceSpectrum AI
// App.tsx · v12.10.25.2 (#2106 /guides - the Help page inside VoiceSpectrum)
// App.tsx · v12.10.12 (#1546 / #1550): /reports is the Reports page (How the day went · Call record).
// App.tsx · v12.10.11.1 (#1475 Help library) · 2026-10-09
// App.tsx · v12.10.9.4 (#1365 an ended support visit says why) · 2026-10-07 · VoiceSpectrum AI
// App.tsx · v12.10.9.3 (#1329): /support-entry - a VoiceSpectrum Support visit opened from a console.
// VoiceSpectrum.Web.T2 · v12.10.9 (Security Phase 1 – #1255/#1256/#1257) · 2026-10-06
// App.tsx - v12.10.9: /reset-password and /invite (sign-in links from email / text) beside /login.
// App.tsx - v12.10.7 (#1163): /contacts is the Contacts page.
// App.tsx - v12.10.5 (#1127): /reports /contacts /schedule /billing /help -> /messages.
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/auth';
import { NavGuardProvider } from './lib/navGuard';
import Shell from './components/Shell';
// v10.0.14.2 HOTFIX: top-level error boundary to prevent blank-page crashes (D17).
import ErrorBoundary from './components/ErrorBoundary';

import FirstLoginPage from './pages/FirstLoginPage';
import LoginPage, { InvitePage, ResetPasswordPage } from './pages/LoginPage';
import SupportVisitEnded from './pages/SupportVisitEnded';
import { readSupportVisit } from './lib/supportVisit';
import { useState } from 'react';
import SetupMfaPage from './pages/SetupMfaPage';
import TenantHomeRedirect from './pages/TenantHomeRedirect';
import MessagesPage from './pages/MessagesPage';
import ContactsPage from './pages/contacts/ContactsPage';   // v12.10.7 (#1163)
import SettingsPage from './pages/SettingsPage';
import WorkflowModalSnapshotPage from './pages/WorkflowModalSnapshotPage';
import WorkflowDesigner from './components/designer/WorkflowDesigner';
import SupportEntryPage from './pages/SupportEntryPage';
import HelpPage from './pages/help/HelpPage';   // v12.10.11.1 (#1475)
import HelpSupportPage from './pages/help/HelpSupportPage';   // v12.10.30 (#2259): Help & Support - the Help page (GuidesHome) is its Help switch
import ReportsPage from './pages/ReportsPage';
import PracticeOfflinePage from './components/PracticeOfflinePage';   // v12.10.30 (#2255)
import { BrowserPhoneHost } from './components/BrowserPhone';   // v12.10.30 (#1155 #1156 #1157): inert unless the Call back feature is on   // v12.10.12 (#1546 T80, #1550 T81)

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      {/* v12.10.30 (#2255): Support Ops took the practice offline - "Your account is taken offline" covers every screen and the sign-in page */}
      <PracticeOfflinePage />
      <Routes>
        {/* Public routes */}
        <Route path="/first-login/:token" element={<FirstLoginPage />} />
        <Route path="/login" element={<LoginGate />} />
        <Route path="/reset-password" element={<ResetPasswordPage key="reset" />} />
        <Route path="/invite" element={<InvitePage key="invite" />} />
        <Route path="/setup-mfa" element={<SetupMfaPage />} />
        <Route path="/support-entry" element={<SupportEntryPage />} />
        <Route path="/welcome" element={<Navigate to="/" replace />} />

        {/* Protected routes wrapped in Shell */}
        <Route element={<RequireAuth><NavGuardProvider><BrowserPhoneHost><Shell /></BrowserPhoneHost></NavGuardProvider></RequireAuth>}>
          <Route index element={<TenantHomeRedirect />} />
          <Route path="/messages" element={<MessagesPage />} />
          {/* v12.10.5 (#1127): Schedule, Reports, Billing, Help are "Coming soon" - their routes go to Messages. */}
          {/* v12.10.7 (#1163): Contacts is live (T14 Contacts Phase 1). */}
          {/* v12.10.12 (#1546 / #1550): Reports is live. */}
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/schedule" element={<Navigate to="/messages" replace />} />
          <Route path="/billing" element={<Navigate to="/messages" replace />} />
          {/* v12.10.11.1 (#1475): Help is live - the Help library, opened in a new browser tab from the left menu. /help?a=<article-id> opens one article. */}
          <Route path="/help" element={<HelpPage />} />
          <Route path="/guides" element={<HelpSupportPage />} />{/* v12.10.30 (#2259): Help & Support - ?tab=tickets | news */}{/* v12.10.25.2 (#2106): the left-menu Help - search + guides in the app; Browse all articles opens /help */}
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/configuration" element={<SettingsPage />} />
          <Route path="/configuration/:section" element={<SettingsPage />} />
          <Route path="/workflows/modal" element={<WorkflowModalSnapshotPage />} />
          <Route path="/workflows/:id" element={<WorkflowDesigner />} />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/workflows" element={<Navigate to="/configuration/workflow" replace />} />
          <Route path="/phone-numbers" element={<Navigate to="/configuration/platform" replace />} />
          <Route path="/call-history" element={<Navigate to="/messages" replace />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
    </ErrorBoundary>
  );
}

// VoiceSpectrum.Web.T2 · v10.0.19.0 · 2026-06-02 · VoiceSpectrum AI

/** v12.10.9.4 (#1365): a VoiceSpectrum Support visit that ended (blocked / timed out) shows why, never the plain sign-in page. */
function LoginGate() {
  const [visit, setVisit] = useState(() => readSupportVisit());
  return visit ? <SupportVisitEnded visit={visit} onSignIn={() => setVisit(null)} /> : <LoginPage key="login" />;
}
